module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_TreeView_16"],"polygon":[{"$":{"points":"9 10 9 8 4 8 4 13 9 13 9 12 16 12 16 16 9 16 9 14 3 14 3 4 0 4 0 0 7 0 7 4 4 4 4 7 9 7 9 6 16 6 16 10 9 10","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_TreeView_16.svg
// module id = p9R4
// module chunks = 1